import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fabric } from 'fabric';


@Component({
  selector: 'app-draw-surface',
  templateUrl: './draw-surface.component.html',
  styleUrls: ['./draw-surface.component.css']
})
export class DrawSurfaceComponent implements OnInit, AfterViewInit  {
  @ViewChild('canvascontainer') canvasContainer: ElementRef;
  @ViewChild('drawcanvas') drawcanvas: ElementRef;

  canvas: any;
  constructor() { }

  ngAfterViewInit(): void {
    this.canvas = new fabric.Canvas('sheet');
    this.canvas.isDrawingMode = true;
    this.canvas.freeDrawingBrush.width = 2;
    this.canvas.freeDrawingBrush.color = "#000000";
    this.canvas.preserveObjectStacking = false;
    var cWidth = this.canvasContainer.nativeElement.offsetWidth;
    if (cWidth > 800) cWidth = 800;
    this.canvas.setWidth(cWidth);
    this.canvas.height = 280;
  }


  clear(){
    if(this.canvas){
      this.canvas.clear();
      this.canvas.clearContext(this.drawcanvas.nativeElement.getContext('2d'));
    }
  }

  ngOnInit(): void {}
  
}
